import Pusher from 'pusher'

// the CHANNELS constant has a known nesting depth so recursion is ok here
// but don't use this against a deeply nested object.
type RecursiveValues<T> = {
  [Prop in keyof T]: T[Prop] extends Record<string, any>
    ? RecursiveValues<T[Prop]>
    : T[Prop]
}[keyof T]

export type ChannelName = RecursiveValues<typeof CHANNELS>

export const CHANNELS = {
  parts: {
    automaticDetection: 'parts.automationDetection',
    create: 'parts.create',
  },
  operation: {
    dominantFeatureDetection: 'operation.dominantFeatureDetection',
    gcodeProgress: 'operation.gcodeProgress',
    initialActionsCreated: 'operation.initialActionsCreated',
  },
  action: {
    generated: 'action.generated',
  },
  program: {
    autoOp: 'program.autoOpProgress',
    surfaceReportReady: 'program.surfaceReportReady',
    estimateMachiningTime: 'program.estimateMachiningTime',
    strategy: 'program.strategy',
    exportToFusion: 'program.exportToFusion',
    fas: 'program.fas',
  },
  billing: {
    subscriptionCreated: 'subscription.created',
  },
} as const

const pusher = new Pusher({
  appId: process.env.PUSHER_APP_ID,
  key: process.env.PUSHER_ACCESS_KEY,
  secret: process.env.PUSHER_SECRET_KEY,
  cluster: process.env.PUSHER_CLUSTER,
  useTLS: true,
})

export default pusher
